import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../../core/layout/Card';
import Button from '../../../core/form/Button';
import SystemTranslationLabelProgressContainer from './SystemTranslationLabelProgressContainer';
import SystemTranslationInstructionAudioProgressContainer from './SystemTranslationInstructionAudioProgressContainer';
import SystemTranslationInstructionVideoProgressContainer from './SystemTranslationInstructionVideoProgressContainer';
import SystemTranslationItemTypeInstructionProgressContainer from './SystemTranslationItemTypeInstructionProgressContainer';
import SystemTranslationEmailTemplateProgressContainer from './SystemTranslationEmailTemplateProgressContainer';

const SystemTranslationLocaleCard = (props) => {
  const title = `${props.locale.key} (${props.locale.language})`;

  let actions = [<Button key="edit" icon="edit" onClick={() => props.onEdit(props.locale)} />];

  if (props.canDelete) {
    actions = [...actions, ' ', <Button key="delete" icon="delete" onClick={() => props.onDelete(props.locale)} />];
  }

  return (
    <Card title={title} actions={actions} style={{ height: '240px' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-around',
        }}
      >
        <SystemTranslationLabelProgressContainer locale={props.locale} />
        <SystemTranslationItemTypeInstructionProgressContainer locale={props.locale} />
        <SystemTranslationInstructionAudioProgressContainer locale={props.locale} />
        <SystemTranslationInstructionVideoProgressContainer locale={props.locale} />
        <SystemTranslationEmailTemplateProgressContainer locale={props.locale} />
      </div>
    </Card>
  );
};

SystemTranslationLocaleCard.propTypes = {
  locale: PropTypes.shape({
    id: PropTypes.string,
    key: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
  }).isRequired,
  canDelete: PropTypes.bool,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
};

SystemTranslationLocaleCard.defaultProps = {
  canDelete: true,
  onDelete: () => {},
  onEdit: () => {},
};

export default SystemTranslationLocaleCard;
